<template>
    <div>
        <el-tabs type="card" v-model="activeLanguageTabName">
            <el-tab-pane v-for="item in languageTemplates" :key="item.language" :name="item.language">
                <span slot="label"><i v-if="item.title == ''" class="el-icon-info" style="margin-right: 5px"></i>{{
                    `[${item.language}]` }}</span>
                <div>
                    <label style="display: block">{{
                        `标题：`
                    }}</label>
                    <el-input v-model="item.title" :disabled="readonly"
                        placeholder="（这里输入的内容会在游戏里展示）"></el-input>
                </div>
                <div style="margin-top: 5px">
                    <label style="display: block">{{
                        `正文（如果太长可以滚动）：`
                    }}</label>
                    <el-input type="textarea" rows="10" v-model="item.content" :disabled="readonly"
                        placeholder="（这里输入的内容会在游戏里展示）"></el-input>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import bizutil from "@/bizutil";

export default {
    data() {
        return {
            activeLanguageTabName: "",
        }
    },

    props: {
        languageTemplates: Array,
        readonly: Boolean,
    },

    async created() {
        // 查询语言集合
        let languages = await bizutil.loadAvailableLanguages();

        // 为每种语言构建模板
        for (let l of languages) {
            let isExists = false;

            if (this.languageTemplates) {
                for (let lt of this.languageTemplates) {
                    if (lt.language == l) {
                        isExists = true;
                        break;
                    }
                }
            }

            if (!isExists) {
                this.languageTemplates.push({
                    language: l,
                    title: "",
                    content: "",
                });
            }
        }

        if (this.languageTemplates && this.languageTemplates.length > 0) {
            this.activeLanguageTabName = this.languageTemplates[0].language;
        }
    },

    methods: {
        /**
         * 获取数据
         * 
         * 这个函数是供父组件直接调用的
         */
        getData() {
            let result = {
                errorMessage: "",
                data: {
                    languageTemplates: [],
                }
            };

            // 确保在各语言的模板中，至少有1个语言模板的标题不是空的
            {
                let isAnyLanguageTemplateTitleValid = false;

                for (let languageTemplate of this.languageTemplates) {
                    if (languageTemplate.title.trim() != "") {
                        isAnyLanguageTemplateTitleValid = true;
                        break;
                    }
                }

                if (!isAnyLanguageTemplateTitleValid) {
                    result.errorMessage = "请至少为1个语言模板填写有效标题";
                    return result;
                }
            }

            result.data.languageTemplates = this.languageTemplates;

            return result;
        },
    }
}
</script>

<style lang="scss" scoped>
::v-deep .el-input.is-disabled .el-input__inner {
    background-color: white;
    color: black;
}

::v-deep .el-textarea.is-disabled .el-textarea__inner {
    background-color: white;
    color: black;
}
</style>
